module.exports = __webpack_public_path__ + "static/media/IMG_5050.898812f8.JPG";